// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"55e1974d","291":"aac15dbd","453":"4f27d163","796":"ae0f6bfc"}[chunkId] + ".chunk.js";
};